import { useEffect, useRef } from "react";
import { socketClient } from "@/services/socketClient";
import { SocketMessage } from "@/model/interface/SocketConnection";

export function useSocketSubscription(
  destination: string | null,
  onMessage: (message: SocketMessage) => void,
  onSubscribed?: () => void,
) {
  const onMessageRef = useRef(onMessage);
  const onSubscribedRef = useRef(onSubscribed);
  onMessageRef.current = onMessage;
  onSubscribedRef.current = onSubscribed;

  useEffect(() => {
    if (!destination) {
      return;
    }
    return socketClient.subscribe(
      destination,
      (message) => onMessageRef.current(message),
      () => onSubscribedRef.current?.(),
    );
  }, [destination]);
}
